
import * as types from './types';
import { JSON_STRING, HttpClient } from '../../../../services/http/http-client';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';

const NavTabModule = getNavTabModule(types.DealsDetails, 'dealsDetails');

// Action Object for DealsRoyalty. Import the types from deals/types.js and Invoke Actions from the Vuex Host Components.
 
export const dealsRoyaltyActions = {
  async [types.DealsRoyaltyData.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const dealsRoyaltyData = await HttpClient.mergeRequests([
      
    ]);
    console.log(dealsRoyaltyData);
    commit(types.DealsRoyaltyData.SET.ALL, dealsRoyaltyData);
  },
  async [types.DealsList.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    
  },
  async [types.DealsList.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    
  },
  async [types.DealsDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

  },
  ...NavTabModule.implementActions(
    'deals_id',
    'deals/deals_id/tab',
    'deals',
    () => router,
    'royalty',
    (value, key) => {
      const { deals } = value;

      return {
        title: key,
        full_title: key,
      }
    }
  ),
  async [types.DealsDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

  },
}
